<template>
    <el-dialog
        custom-class="user-org-dialog"
        title="选择人员"
        top="4vh"
        width="60%"
        height="80vh"
        :visible.sync="isInnerShowUserOrg"
        append-to-body
      >
            <div>
                <div class="tools-bar">
                        <span><el-tag type="primary">员工列表</el-tag></span>
                        <div class="tools-search" @keyup.enter="handleSearchInDept">
                            <el-input maxlength="100" v-model.trim="empNameInDept" placeholder="员工姓名">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearchInDept"></el-button>
                            </el-input>
                        </div>
                </div>
                <template v-if="multiple">
                    <el-table  :data="employeeListInDept" @selection-change="handleSelectionChangeInDept" border style="width: 100%;" v-loading="inDpetloading" tooltip-effect="dark" >
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="trueName" label="姓名"></el-table-column>
                        <el-table-column prop="departmentName" label="部门"></el-table-column>
                        <el-table-column prop="roleName" label="角色"></el-table-column>
                        <el-table-column prop="positionName" :show-overflow-tooltip="true" label="岗位"></el-table-column>
                    </el-table>
                </template>
                <template v-else>
                    <el-table  :data="employeeListInDept" highlight-current-row @current-change="handleSelectionChangeInDept" border style="width: 100%;" v-loading="inDpetloading" tooltip-effect="dark" >
                    <el-table-column prop="trueName" label="姓名"></el-table-column>
                    <el-table-column prop="departmentName" label="部门"></el-table-column>
                    <el-table-column prop="roleName" label="角色"></el-table-column>
                    <el-table-column prop="positionName" :show-overflow-tooltip="true" label="岗位"></el-table-column>
                    </el-table>
                </template>
                <!-- 分页 -->
                <el-row type="flex" justify="end" style="margin-top:10px">
                    <el-pagination
                        background
                        layout="total,sizes, prev, pager, next"
                        :total="totalPageNumInDept"
                        :current-page="currentPageInDept"
                        :page-size="pageSizeInDept"
                        :page-sizes="[10, 20, 50, 100, 300, 1000]"
                        @current-change="queryFormDataInDept"
                        @size-change="queryFormDataByPageSize"
                        >
                    </el-pagination>
                </el-row>
            </div>
          <span slot="footer" class="dialog-footer">
                <el-button @click="isInnerShowUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">确 定</el-button>
            </span>
      </el-dialog>

</template>

<script>
    import { getDepartmentTreeList, getEmployeeListByDepartmentId, getModelFormReportList, getModelServiceList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import Department from '@/components/Department';
    import { isEmpty, cloneDeep } from 'lodash';
    export default {
        mixins: [ mixinsNav ],
        components: {
            Department: Department
        },
        data () {
            return {
                isInnerShowUserOrg: false,
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                isShowTree: false,
                empNameInDept: '', // 分配在此部门内员工
                inDpetloading: false,
                employeeListInDept: [], // 分配在此部门内员工
                currentPageInDept: 1, // 当前页码
                pageSizeInDept: 10, // 每页条数
                totalPageNumInDept: 1, // 总页数

                unInDpetloading: false,
                empNameUnInDept: '',
                selectedUserList: [], // 已选择的员工列表数据
                currentPageUnInDept: 1, // 当前页码
                pageSizeUnInDept: 10, // 每页条数
                totalPageNumUnInDept: 1, // 总页数

                employeeDepartment: {
                    employeeId: '',
                    departmentId: ''
                },
                selectMap: new Map(),
                currentDepartmentId: '', // 当前点击的部门节点
                selectedUserIds: '', // 选中的员工ID
                selectedUserNames: '', // 选中的员工名称
                selectedRemovedUserIds: '', // 选中的员工ID
                extendDataIds: '', // 选中的扩展数据ID
                tableColumns: [],
                pageData: [],
                tableLoading: false,
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 100000, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                userExtendConfig: {}
            };
        },
        props: {
            selectedUser: {
                type: Object,
                default: function () {
                    return {
                        selectedUserIds: '',
                        selectedUserNames: '',
                        extendDataIds: ''
                    };
                }
            },
            isShowUserOrg: {
                type: Boolean,
                default: false
            },
            filterUsers: {// 需要过滤不显示的人员信息
                type: String,
                default: ''
            },
            multiple: {
                type: Boolean,
                default: false
            },
            field: { // 自定义属性字段
                type: Object
            },
            formData: {// 自定义属性表单数据
                type: Object
            },
            formConfig: {
                type: Object
            }
        },
        created () {
            // this._initPage();

        },
        methods: {
            async _initPage () {
                this.isInnerShowUserOrg = this.isShowUserOrg;
                this.selectMap = new Map();
                if (!isEmpty(this.selectedUser.selectedUserIds)) {
                    this.selectedUserIds = this.selectedUser.selectedUserIds;
                    this.selectedUserNames = this.selectedUser.selectedUserNames;
                    this.extendDataIds = this.selectedUser.extendDataIds;
                }
                this._getListData();
                this._getTreeData();
            },
            async _getListData () {
                await this.handleSearchInDept();
                await this.handleSearchUnInDept();
            },
            async _getTreeData () {
                if (!this.field || !this.field.ext1) {
                    let departmentTreeList = await getDepartmentTreeList();
                    setTimeout(() => { // 调用子组件的方法
                        this.$refs.treeChild._refreshTreeData(departmentTreeList);
                    }, 0);
                    this.treeData = departmentTreeList;
                    this.isShowTree = true;
                }
            },
            handleTreeNode (data, node, tree) {
                this.currentDepartmentId = data.id;
                this.currentPageInDept = 1;
                this.handleSearchInDept();
            },
            async handleSearchInDept () {
                this.inDpetloading = true;
                let positionIds = null;
                if (this.field && this.field.ext1) { // 假如有岗位规则的约束时增加岗位规则
                    positionIds = JSON.parse(this.field.ext1).join(',');
                }
                let employeeInDeptListData = await getEmployeeListByDepartmentId(this.currentPageInDept, this.pageSizeInDept, this.currentDepartmentId, this.empNameInDept, positionIds);
                let sourceUser = cloneDeep(employeeInDeptListData.data);
                let filterUser = [];
                if (!isEmpty(this.selectedUser.selectedUserIds)) {
                    let selectedIds = this.selectedUser.selectedUserIds.split(',');
                    for (let j = 0; j < selectedIds.length; j++) {
                        this.selectMap.set(selectedIds[j], selectedIds[j]);
                    }
                }
                if (!isEmpty(this.filterUsers)) {
                    let filterIds = this.filterUsers.split(',');
                    let filterMap = new Map();
                    for (let j = 0; j < filterIds.length; j++) {
                        filterMap.set(filterIds[j], filterIds[j]);
                    }
                    for (let i = 0; i < sourceUser.length; i++) {
                        if (!filterMap.has(sourceUser[i].id)) {
                            filterUser.push(sourceUser[i]);
                        }
                    }
                } else {
                    filterUser = sourceUser;
                }
                this.employeeListInDept = filterUser;
                this.currentPageInDept = employeeInDeptListData.currentPage;
                this.pageSizeInDept = employeeInDeptListData.pageSize;
                this.totalPageNumInDept = employeeInDeptListData.totalPageNum;
                this.inDpetloading = false;
            },
            queryFormDataInDept (currentPageInDept) {
                this.currentPageInDept = currentPageInDept;
                this._getListData();
            },
            queryFormDataByPageSize (pageSize) {
                this.pageSizeInDept = pageSize;
                this._getListData();
            },
            async handleSearchUnInDept () {
                this.unInDpetloading = true;
                if (!isEmpty(this.selectedUserIds)) {
                    let ids = this.selectedUserIds.split(',');
                    let names = this.selectedUserNames.split(',');
                    let selectedData = [];
                    for (var i = 0; i < ids.length; i++) {
                        selectedData.push({id: ids[i], trueName: names[i]});
                    }
                    this.selectedUserList = selectedData;
                } else {
                    this.selectedUserList = [];
                }
                this.unInDpetloading = false;
            },
            queryFormDataUnInDept (currentPageUnInDept) {
                this.currentPageUnInDept = currentPageUnInDept;
                this._getListData();
            },
            async handleRemoveSelectedUser () {
                if (!isEmpty(this.selectedRemovedUserIds)) {
                    let newIds = this.selectedRemovedUserIds.split(',');
                    let ids = this.selectedUserIds.split(',');
                    let names = this.selectedUserNames.split(',');
                    let extendDataIds = [];
                    if (!isEmpty(this.extendDataIds)) {
                        extendDataIds = this.extendDataIds.split(',');
                    }
                    let selectedData = [];
                    this.selectedUserIds = '';
                    this.selectedUserNames = '';
                    this.extendDataIds = '';
                    let removedMap = new Map();
                    for (var j = 0; j < newIds.length; j++) {
                        removedMap.set(newIds[j], newIds[j]);
                    }
                    for (var i = 0; i < ids.length; i++) {
                        if (!removedMap.has(ids[i])) {
                            selectedData.push({id: ids[i], trueName: names[i]});
                            if (isEmpty(this.selectedUserIds)) {
                                this.selectedUserIds = ids[i];
                                this.selectedUserNames = names[i];
                                this.extendDataIds = extendDataIds[i];
                            } else {
                                this.selectedUserIds = this.selectedUserIds + ',' + ids[i];
                                this.selectedUserNames = this.selectedUserNames + ',' + names[i];
                                this.extendDataIds = this.extendDataIds + ',' + extendDataIds[i];
                            }
                        } else {
                            this.selectMap.delete(ids[i]);
                        }
                    }
                    this.selectedUserList = selectedData;
                }
            },
            handleSelectionChangeInDept (rows) {
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (!this.selectMap.has(row.id)) {
                                    if (isEmpty(this.selectedUserIds)) {
                                        this.selectedUserIds = row.id;
                                        this.selectedUserNames = row.trueName;
                                        this.extendDataIds = row.extendDataId;
                                    } else {
                                        this.selectedUserIds = this.selectedUserIds + ',' + row.id;
                                        this.selectedUserNames = this.selectedUserNames + ',' + row.trueName;
                                        this.extendDataIds = this.extendDataIds + ',' + row.extendDataId;
                                    }
                                    this.selectMap.set(row.id, row.id);
                                }
                            }
                        });
                    } else {
                        this.selectedUserIds = rows.id;
                        this.selectedUserNames = rows.trueName;
                        this.extendDataIds = rows.extendDataId;
                    }
                    this.handleSearchUnInDept();
                }
            },
            handleSelectionRemovedUser (rows) {
                this.selectedRemovedUserIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedUserIds)) {
                                this.selectedRemovedUserIds = row.id;
                            } else {
                                this.selectedRemovedUserIds = this.selectedRemovedUserIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            confirmClick () {
                this.selectedUser.selectedUserIds = this.selectedUserIds;
                this.selectedUser.selectedUserNames = this.selectedUserNames;
                if (this.formData) {
                    this.formData[this.field.formField] = this.selectedUser.selectedUserIds;
                    this.formData[this.field.formField + '-user'] = this.selectedUser.selectedUserNames;
                    this.formData[this.field.formField + '-userExtendInfo'] = this.extendDataIds;
                }
                console.log(this.selectedUser);
                this.$emit('nodeClick', this.selectedUser);
                if (this.field && this.field.options) {
                    let ext = this.field.options.ext2;
                    if (ext) {
                        let obj = JSON.parse(ext);
                        if (obj.showUserDetails) {
                            // 获取当前用户的扩展字段
                            this.$emit('showUserDetail', this.extendDataIds);
                        }
                        if (obj.setDataRelation && obj.userFieldDataRelation) { // 获取要赋值的值
                            let userFieldDataRelation;
                            if (typeof (obj.userFieldDataRelation) === 'object') {
                                userFieldDataRelation = obj.userFieldDataRelation;
                            } else {
                                userFieldDataRelation = JSON.parse(obj.userFieldDataRelation);
                            }
                            let param = {extendDataIds: this.extendDataIds, userFieldDataRelation: userFieldDataRelation};
                            this.$emit('autoUserComplateData', param);
                        }
                    }
                }
                this.isInnerShowUserOrg = false;
            },
            async getDefaultUserFieldConfig () {
                this.loading = true;
                let param = {};
                param.modelTypes = '7';
                let formData = await getModelServiceList(
                    Object.assign(
                        {
                            currentPage: 0,
                            pageSize: 10
                        },
                        param
                    )
                );
                if (formData.data.length > 0) {
                    this.userExtendConfig = formData.data[0];
                    this.showDetailList();
                }
                this.loading = false;
            },
            async showDetailList () {
                let param = {};
                param.formId = this.userExtendConfig.formId;
                param.modelId = this.userExtendConfig.id;
                param.moreIds = this.extendDataIds;
                param.page = JSON.stringify(this.page);
                param.isFilterDuplicateData = false;
                let formData = await getModelFormReportList(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                }, param));
                if (formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    this.pageData = tableDatas;
                }
                if (formData.otherData.tableColumns) {
                    this.tableColumns = [];
                    let _tableColumns = formData.otherData.tableColumns;
                    this.allTableColumns = cloneDeep(_tableColumns);
                    _tableColumns.forEach(item => {
                        if (item.type !== 'divider' && item.label !== '密码') { // 隐藏分割线
                            this.tableColumns.push(item);
                        }
                    });
                }
                this.$emit('showUserDetail', this.tableColumns, this.pageData);
            }
        }
    };
</script>

<style lang="less">
    .userOrgPop {
        height: 60vh;
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
            height: 60vh;
            .el-container{
                height: 60vh;
                .el-aside{
                    height: 60vh;
                }
            }
        }
        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
        .depart-tree-box{
            height: ~"calc(60vh - 40px)";
            .department-tree{
                height: ~"calc(60vh - 40px)";
                max-height: ~"calc(60vh - 40px)";
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserOrgPop/UserPop.vue